import script from "./CarNumInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CarNumInput.vue?vue&type=script&setup=true&lang=js"

import "./CarNumInput.vue?vue&type=style&index=0&id=60ccdca3&lang=css"

const __exports__ = script;

export default __exports__